/* eslint-disable no-undef */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles, Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ControlledDialog from "../../components/ControlledDialog/ControlledDialog";

const KJUR = require("jsrsasign");
const DIALOG_TIME = 1800000; // 1800 sec => 30 mints
const LOGIN_CALL_TIME = 300000; // 300 sec =>  5 mints

ZoomMtg.setZoomJSLib("https://source.zoom.us/3.12.0/lib", "/av");
ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
// loads language files, also passes any error messages to the ui
ZoomMtg.i18n.load("en-US");
ZoomMtg.i18n.reload("en-US");

const styles = (theme) => ({
	margin: {
		margin: theme.spacing(2),
	},
	extendedIcon: {
		marginRight: theme.spacing.unit,
	},
	smallAvatar: {
		width: 30,
		height: 30,
		marginTop: 5,
	},
});

const zoomMeeting = document.getElementById("zmmtg-root");
class WorkflowsApproval extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDialogOpen: false,
			isLoading: false,
		};
	}

	setDialogOpen = () => {
		this.timerId = setTimeout(() => {
			this.setState({
				isDialogOpen: true,
			});
		}, DIALOG_TIME);
	};

	onJoin = () => {
		let meetingObj = localStorage.getItem("lmsMeetingConfig") ? JSON.parse(localStorage.getItem("lmsMeetingConfig")) : {};
		const meetingConfig = {
			sdkKey: process.env.REACT_APP_SUB_API_KEY,
			sdkSecret: process.env.REACT_APP_API_SECRET_KEY,
			meetingNumber: meetingObj.meetingNumber || 81188942831,
			leaveUrl: meetingObj.leaveUrl || process.env.REACT_APP_LMS_URL,
			userName: meetingObj.userName || "Unknown Student",
			userEmail: meetingObj.userEmail || "student@ucl.edu.pk",
			passWord: meetingObj.password || "htwave",
			role: meetingObj.role || 0,
		};

		console.log("Launch meeting function");

		//zoomMeeting.style.display = "flex";
		//zoomMeeting.style.height = "100%";
		//zoomMeeting.style.width = "100%";
		//zoomMeeting.style.position = "fixed";
		//zoomMeeting.style.zIndex = "1";
		//zoomMeeting.style.backgroundColor = "black";

		const iat = Math.round(new Date().getTime() / 1000) - 30;
		const exp = iat + 60 * 60 * 2;

		const oHeader = { alg: "HS256", typ: "JWT" };

		const oPayload = {
			sdkKey: process.env.REACT_APP_SUB_API_KEY,
			mn: meetingConfig.meetingNumber,
			role: meetingConfig.role,
			iat: iat,
			exp: exp,
			appKey: process.env.REACT_APP_SUB_API_KEY,
			tokenExp: iat + 60 * 60 * 2,
		};

		const sHeader = JSON.stringify(oHeader);
		const sPayload = JSON.stringify(oPayload);
		const signature = KJUR.jws.JWS.sign("HS256",sHeader,sPayload,process.env.REACT_APP_API_SECRET_KEY);
		console.log("sig: ", signature);
		ZoomMtg.init({
			leaveUrl: meetingConfig.leaveUrl,
			disableInvite: true,
			meetingInfo: ["topic", "host"],
			success() {
				ZoomMtg.join({
					meetingNumber: meetingConfig.meetingNumber,
					userName: meetingConfig.userName,
					signature,
					userEmail: meetingConfig.userEmail,
					sdkKey: meetingConfig.sdkKey,
					passWord: meetingConfig.passWord,
					success() {
						console.log("join meeting success");
					},
					error(error) {
						console.log("Joining Error: ", error);
					},
				});
			},
			error(error) {
				console.log("Init Error: ", error);
			},
		});
		this.setDialogOpen();
	};

	onYesNoClick = async (value) => {
		if (value === 1) {
			this.setState({
				isLoading: true,
			});
			const { classObject = {} } = localStorage.getItem("lmsMeetingConfig") ? JSON.parse(localStorage.getItem("lmsMeetingConfig")) : {};
			const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME }/lms/C104CommonAcademicsAttendanceStudentsLogSave?classId=${classObject.id }&typeId=${1}`;
			await fetch(url, {
				method: "POST",
				headers: new Headers({
					Authorization: "Bearer " + localStorage.getItem("lmsToken"),
				}),
			})
			.then((res) => {
				if (!res.ok) {
					throw res;
				}
				return res.json();
			})
			.then(
				(json) => {
					if (json.CODE === 1) {
						this.setState({ isDialogOpen: false });
						clearInterval(this.timerId);
						this.setDialogOpen();
					} else {
						alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
					}
				},
				(error) => {
					if (error.status === 401) {
						this.setState({
							isLoginMenu: true,
							isReload: false,
						});
					} else {
						alert("Operation Faild ! Please try again");
					}
				}
			);
			this.setState({
				isLoading: false,
			});
		} else {
			this.setState({ isDialogOpen: false });
			clearInterval(this.timerId);
			this.setDialogOpen();
		}
	};

	componentDidMount() {
		this.onJoin();
		this.loginCallFunction();
	}

	loginCallFunction = () => {
		this.timerId2 = setInterval(() => {
			this.loginValidate();
		}, LOGIN_CALL_TIME);
	};

	loginValidate = async () => {
		const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C00JwtValidateToken`;
		await fetch(url, {
			method: "GET",
			headers: new Headers({
				Authorization: "Bearer " + localStorage.getItem("lmsToken"),
			}),
		})
			.then((res) => {
				if (!res.ok) {
					throw res;
				}
				return res.json();
			})
			.then(
				(json) => {
					if (json) {
						console.log("Valid User");
					} else {
						console.log("Getting invalid user response");
					}
				},
				(error) => {
					if (error.status === 401) {
						window.localStorage.removeItem("lmsData");
						window.localStorage.removeItem("lmsToken");
						window.localStorage.removeItem("lmsStudentId");
						window.localStorage.removeItem("lmsMeetingConfig");
						window.location.href = process.env.REACT_APP_LMS_URL;
					} else {
						console.log("API Problem to validate");
					}
				}
			);
	};

	componentWillUnmount() {
		clearInterval(this.timerId);
		clearInterval(this.timerId2);
	}

	render() {
		const { courseName = "N/A" } = localStorage.getItem("lmsMeetingConfig") ? JSON.parse(localStorage.getItem("lmsMeetingConfig")) : {};
		const content = "Are you still conected with online class ?";
		const title = "Confirmation";
		const actions = (
			<Fragment>
				<Button
					disabled={this.state.isLoading}
					onClick={() => this.onYesNoClick(1)}
					color="primary"
					variant="contained"
				>
					{this.state.isLoading ? (
						<CircularProgress style={{ height: 25, width: 25 }} />
					) : (
						"Yes"
					)}
				</Button>
				<Button
					disabled={this.state.isLoading}
					onClick={() => this.onYesNoClick(0)}
					color="primary"
					variant="outlined"
				>
					No
				</Button>
			</Fragment>
		);

		return (
			<Fragment>
				<ControlledDialog
					disableBackdropClick
					disableEscapeKeyDown
					disableScrollLock
					title={title}
					open={this.state.isDialogOpen}
					hideClose
					actions={actions}
					handleClose={() => this.setState({ isDialogOpen: false })}
					content={content}
				/>
				<div
					style={{
						position: "fixed",
						zIndex: 1300,
						backgroundColor: "#23233357",
						color: "white",
						marginTop: "3%",
						padding: 5,
					}}
				>
					Class: {courseName}
				</div>
				{/* <Button onClick={() => window.location.replace(classObject.meetingJoinUrl)} color="primary" variant="contained" style={{
					position: 'fixed',
					zIndex: 1300,
					color: 'white',
					marginTop: '6%',
					padding: 5,
					textTransform: 'capitalize'
				}}>
					Open Zoom App
				</Button> */}
				<center>
					<CircularProgress style={{ marginBottom: 20, marginTop: "10%" }} />{" "}
					<br />
					<span>Please Wiat</span>
				</center>
			</Fragment>
		);
	}
}
WorkflowsApproval.propTypes = {
	classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(WorkflowsApproval);
